import React, { useState } from 'react';
import WorksiteDocument from "./WorksiteDocument";
import Icon from "../../ui-components/Icon";
import {SECTIONS_PLACEHOLDERS} from "@pages/WorksitesDocuments/utils/constants";
import EmptyStatePlaceholder from "@pages/WorksitesDocuments/EmptyStatePlaceholder";
import {EllipsisVerticalIcon} from "@heroicons/react/24/outline";
import {Draggable} from "react-beautiful-dnd";
import Placeholder from "@ui-components/Placeholder";
import AuthenticationService from "../../services/AuthenticationService";
import Checkbox from "../../ui-components/Checkbox";


const DocumentsGroup = ({
	group,
	groupIndex,
	sectionKey,
	alternateColor = "",
	onDocumentSelected,
	dnd=false,
	dndGroupProvider,
	dndPlaceholder,
	onSelectAllGroupDocuments,
}) => {

	const [open, setOpen] = useState(false);
	const userData = AuthenticationService.getUserData()
	/*
	visibleDocuments is an array of documents that are visible
	meaning that their name includes the search input
	originalIndex is the index of the document in the group and it is used to
	correctly refer to the document
	 */
	const visibleDocuments = group.documents
		?.map((d, i) => ({...d, originalIndex: i}))
		?.filter(d => d.visible);

	const emptyPlaceholderData = SECTIONS_PLACEHOLDERS[group.key || ""] || {};
	emptyPlaceholderData.customActionComponent = group.groupActions?.upload?.actionComponent();
	const emptyPlaceholder = <EmptyStatePlaceholder {...emptyPlaceholderData} />;

	const dragNdroppable = group.lst_visibility?.map(v=>v.id).includes(userData.id)
		|| (group.lst_visibility?.some(v=>v.flg_internal) && userData.role_type === "admin")
		|| group.flg_public
		|| group.cod_author === userData.id
	  || group.flg_internal_author
	const editable = dragNdroppable

	const atLeastOneSelected = visibleDocuments?.some(d => d.selected);
	const allAreSelected = visibleDocuments?.every(d => d.selected) && atLeastOneSelected;
	const selectedDocuments = visibleDocuments?.filter(d => d.selected);


	return (
		<div className={`bg-white flex flex-col ${sectionKey === "users_documents" ? "py-4 px-6" : "p-6"} gap-y-5 border border-slate-500`} style={{marginTop: "-1px"}}>
			<div className="flex flex-row gap-8">
				<div className={"flex items-center justify-between flex-1"}>
					<div className="flex items-center gap-x-4">
						<div {...dndGroupProvider.dragHandleProps} className={dragNdroppable ? "" : "invisible -mr-4"}>
							<EllipsisVerticalIcon className={`${dragNdroppable ? "h-6" : "w-0"} text-gray-600 cursor-move`} />
						</div>
						<div>
							<Checkbox
								checked={allAreSelected}
								onChange={() => {
									onSelectAllGroupDocuments(sectionKey, groupIndex, !allAreSelected);
								}}
							/>
						</div>
						{group.groupActions?.edit && editable && <div>
							{group.groupActions.edit.actionComponent()}
						</div>}
						<h2
							className="text-xl md:text-2xl font-extrabold leading-7 text-black-500 md:whitespace-nowrap flex gap-4 items-center">
							<span>{group.title}</span>
						</h2>
					</div>
					{group.groupActions?.upload && <div>
						{group.groupActions.upload.actionComponent()}
					</div>}
				</div>
				<div className="flex">
					<Icon
						iconName={open? "ChevronUpIcon" : "ChevronDownIcon"}
						className="w-6 cursor-pointer"
						onClick={() => setOpen(!open)}
					/>
				</div>
			</div>
			{open && <div className={`flex flex-col w-full ${sectionKey === "users_documents" ? "mb-2" : ""}`}>
				{!visibleDocuments && (
					<div className="flex flex-col">
						{Array(2).fill(0).map((_, index) => (
							<Placeholder key={index} height="h-10" />
						))}
					</div>
				)}
				{!!visibleDocuments && !visibleDocuments.length && emptyPlaceholder}
				{visibleDocuments?.map((document, index) => (
					<Draggable
						key={`document-${document.id || index}`}
						draggableId={`document-${document.id}`}
						index={index}
					>
						{(provided) => (
							<div
								ref={provided.innerRef}
								{...provided.draggableProps}
							>
								<WorksiteDocument
									document={document}
									sectionKey={sectionKey}
									groupIndex={groupIndex}
									documentIndex={document.originalIndex}
									onDocumentSelected={onDocumentSelected}
									dndDocumentProvider={provided}
									dnd={dnd}
									backgroundColor={index % 2 === 0 ? alternateColor || "bg-white" : "bg-white"}
								/>
							</div>
						)}
					</Draggable>
				))}
				{dndPlaceholder}
			</div>}
		</div>
	)
}

export default DocumentsGroup;